import { render, staticRenderFns } from "./aRoomDetailCar.vue?vue&type=template&id=dc8b27ee&scoped=true"
import script from "./aRoomDetailCar.vue?vue&type=script&lang=js"
export * from "./aRoomDetailCar.vue?vue&type=script&lang=js"
import style0 from "./aRoomDetailCar.vue?vue&type=style&index=0&id=dc8b27ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8b27ee",
  null
  
)

export default component.exports